import React from 'react';
import { StyledPlus } from './styles';

const Plus = ({ handleClick }) => (
  <StyledPlus className="nav-activity-icon" onClick={handleClick} />
);

export default React.memo(Plus);
